var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCupom1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FAE6E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3166 36.6328C36.073 36.6328 32.6329 40.0729 32.6329 44.3164V52C32.6329 56.2436 36.073 59.6837 40.3166 59.6837H55.6838C59.9273 59.6837 63.3674 56.2436 63.3674 52C61.2456 52 59.5256 50.28 59.5256 48.1582C59.5256 46.0365 61.2456 44.3164 63.3674 44.3164C63.3674 40.0729 59.9273 36.6328 55.6838 36.6328H40.3166Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3164 38.2655C36.9746 38.2655 34.2655 40.9746 34.2655 44.3164V52C34.2655 55.3418 36.9746 58.0508 40.3164 58.0508H55.6836C58.5661 58.0508 60.9779 56.0353 61.5863 53.3366C59.4371 52.5976 57.8927 50.5583 57.8927 48.1582C57.8927 45.7581 59.4371 43.7188 61.5863 42.9798C60.9779 40.2811 58.5661 38.2655 55.6836 38.2655H40.3164ZM31 44.3164C31 39.1711 35.1711 35 40.3164 35H55.6836C60.8289 35 65 39.1711 65 44.3164C65 45.2181 64.269 45.9492 63.3672 45.9492C62.1472 45.9492 61.1582 46.9382 61.1582 48.1582C61.1582 49.3782 62.1472 50.3672 63.3672 50.3672C64.269 50.3672 65 51.0982 65 52C65 57.1453 60.8289 61.3164 55.6836 61.3164H40.3164C35.1711 61.3164 31 57.1453 31 52V44.3164Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1864 36.6328C53.9291 36.6328 54.5311 37.2348 54.5311 37.9774L54.5311 42.9718C54.5311 43.7144 53.9291 44.3164 53.1864 44.3164C52.4438 44.3164 51.8418 43.7144 51.8418 42.9718L51.8418 37.9774C51.8418 37.2348 52.4438 36.6328 53.1864 36.6328Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1864 52C53.9291 52 54.5311 52.602 54.5311 53.3446L54.5311 58.339C54.5311 59.0816 53.9291 59.6836 53.1864 59.6836C52.4438 59.6836 51.8418 59.0816 51.8418 58.339L51.8418 53.3446C51.8418 52.602 52.4438 52 53.1864 52Z",
    fill: "#A51713"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1864 46.2373C53.9291 46.2373 54.5311 46.8393 54.5311 47.5819L54.5311 48.7345C54.5311 49.4771 53.9291 50.0791 53.1864 50.0791C52.4438 50.0791 51.8418 49.4771 51.8418 48.7345L51.8418 47.5819C51.8418 46.8393 52.4438 46.2373 53.1864 46.2373Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCupom1);
export default __webpack_public_path__ + "static/media/icon_cupom_1.a58f1e6104ab5129ad08759427a9f530.svg";
export { ForwardRef as ReactComponent };